<template>
  <AddressPage path="address" />
</template>
